import React from "react"
import { MobergColumn, MobergFontFamily, MobergInputLabel } from "../../../../../../../Moberg"
import { getAnalyticDisplayName, getQEEGTrendParameterSummary, QEEGTrendAnalytic } from "../../../Types/AnalysisDetails"

interface QEEGTrendParametersProps {
    analytic: QEEGTrendAnalytic
}

export const QEEGTrendParameters: React.FC<QEEGTrendParametersProps> = ({ analytic }) => (
    <MobergColumn gap="8px">
        <MobergInputLabel text={`${getAnalyticDisplayName(analytic)} parameters`} />
        <span data-testid="qeeg-trend-parameters" style={{ fontFamily: MobergFontFamily.REGULAR, color: "var(--color-text-primary)" }}>
            {getQEEGTrendParameterSummary(analytic)}
        </span>
        <span style={{ fontFamily: MobergFontFamily.REGULAR, fontSize: 12, color: "var(--text-secondary-color)" }}>
            These parameters are fixed and cannot be edited.
        </span>
    </MobergColumn>
)
